module.exports = __webpack_public_path__ + "img/19_rain.9bdb58b7.jpg";